export default __webpack_public_path__ + "static/media/lawstud-io-icon.d9eb7177.svg";